module.exports = __webpack_public_path__ + "static/img/11.597716e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/zh/11.png
// module id = LU5+
// module chunks = 0